import { apiSlice } from "./apiSlice";
import { CUSTOMERS_URL } from "../constants";

const customersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCustomers: builder.query({
      query: (data) => ({
        url: `${CUSTOMERS_URL}?${data.query ? data.query : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    updateCustomer: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/${data._id}`,
        method: "PUT",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    createCustomerOtp: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/createCustomerOtp/${data.mobileNumber}`,
        method: "POST",
        // body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    customerLogin: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/customerLogin`,
        method: "POST",
        body: data,
        // headers: {
        //   Authorization: `Bearer ${data.token}`,
        // },
      }),
    }),
    customerTableLogin: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/customerTableLogin`,
        method: "POST",
        body: data,
        // headers: {
        //   Authorization: `Bearer ${data.token}`,
        // },
      }),
    }),
    updateMyDetails: builder.mutation({
      query: ({ token, ...body }) => ({
        url: `${CUSTOMERS_URL}/updateMyDetails`,
        method: "PUT",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    removeFromFavourites: builder.mutation({
      query: ({ token, ...body }) => ({
        url: `${CUSTOMERS_URL}/removeFromFavourites`,
        method: "PUT",
        body,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getMyDetails: builder.query({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/getMyDetails`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const {
  useGetCustomersQuery,
  useUpdateCustomerMutation,
  useCreateCustomerOtpMutation,
  useCustomerLoginMutation,
  useCustomerTableLoginMutation,
  useUpdateMyDetailsMutation,
  useRemoveFromFavouritesMutation,
  useGetMyDetailsQuery,
} = customersApiSlice;
